import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { ArrowUpDown, Image, Music, Video, File } from 'lucide-react';

type FileTypeFilter = 'all' | 'photo' | 'audio' | 'video' | 'other';
type SortField = 'name' | 'size' | 'date' | 'type';
type SortDirection = 'asc' | 'desc';

interface OrphanedMediaFiltersProps {
  fileTypeFilter: FileTypeFilter;
  onFileTypeFilterChange: (filter: FileTypeFilter) => void;
  sortField: SortField;
  sortDirection: SortDirection;
  onSortFieldChange: (field: SortField) => void;
  onSortDirectionToggle: () => void;
  filteredCount: number;
}

const OrphanedMediaFilters: React.FC<OrphanedMediaFiltersProps> = ({
  fileTypeFilter,
  onFileTypeFilterChange,
  sortField,
  sortDirection,
  onSortFieldChange,
  onSortDirectionToggle,
  filteredCount
}) => {
  return (
    <div className="flex flex-wrap gap-3 items-center bg-white/5 rounded-lg p-4 border border-white/10">
      {/* Filtro por Tipo */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-white/60">Tipo:</span>
        <Select value={fileTypeFilter} onValueChange={(value) => onFileTypeFilterChange(value as FileTypeFilter)}>
          <SelectTrigger className="w-[140px] bg-black/40 border-white/20 text-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-black border-white/20 z-50">
            <SelectItem value="all" className="text-white hover:bg-white/10">
              <div className="flex items-center gap-2">
                <File className="h-4 w-4" />
                Todos
              </div>
            </SelectItem>
            <SelectItem value="photo" className="text-white hover:bg-white/10">
              <div className="flex items-center gap-2">
                <Image className="h-4 w-4" />
                Fotos
              </div>
            </SelectItem>
            <SelectItem value="audio" className="text-white hover:bg-white/10">
              <div className="flex items-center gap-2">
                <Music className="h-4 w-4" />
                Áudios
              </div>
            </SelectItem>
            <SelectItem value="video" className="text-white hover:bg-white/10">
              <div className="flex items-center gap-2">
                <Video className="h-4 w-4" />
                Vídeos
              </div>
            </SelectItem>
            <SelectItem value="other" className="text-white hover:bg-white/10">
              <div className="flex items-center gap-2">
                <File className="h-4 w-4" />
                Outros
              </div>
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Ordenar por */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-white/60">Ordenar:</span>
        <Select value={sortField} onValueChange={(value) => onSortFieldChange(value as SortField)}>
          <SelectTrigger className="w-[160px] bg-black/40 border-white/20 text-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-black border-white/20 z-50">
            <SelectItem value="name" className="text-white hover:bg-white/10">Nome</SelectItem>
            <SelectItem value="size" className="text-white hover:bg-white/10">Tamanho</SelectItem>
            <SelectItem value="date" className="text-white hover:bg-white/10">Data de envio</SelectItem>
            <SelectItem value="type" className="text-white hover:bg-white/10">Tipo</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Toggle de Direção */}
      <Button
        onClick={onSortDirectionToggle}
        variant="ghost"
        size="sm"
        className="text-white hover:bg-white/10"
        title={sortDirection === 'asc' ? 'Ordem crescente' : 'Ordem decrescente'}
      >
        <ArrowUpDown className="h-4 w-4 mr-2" />
        {sortDirection === 'asc' ? 'A-Z' : 'Z-A'}
      </Button>

      {/* Contador de Resultados */}
      <div className="text-sm text-white/60 ml-auto">
        {filteredCount} arquivo{filteredCount !== 1 ? 's' : ''} encontrado{filteredCount !== 1 ? 's' : ''}
      </div>
    </div>
  );
};

export default OrphanedMediaFilters;
